import { toast } from 'react-toastify';

export function openAppPathInNewTab(path) {
  const url = `${window.location.origin}${path}`;
  window.open(url, '_blank', 'noopener,noreferrer');
}

export async function copyAppPathToClipboard(path, successMessage = 'Link copied') {
  const url = `${window.location.origin}${path}`;
  try {
    await navigator.clipboard.writeText(url);
    toast.success(successMessage);
  } catch {
    toast.error('Could not copy link');
  }
}
